module.exports = __webpack_public_path__ + "img/01_no.b4877f00.svg";